import React from "react";

const ErrorIcon = () => {
    return (
        <svg width="16" height="16" fill="none">
            <circle
                cx="8"
                cy="8"
                r="6.2"
                transform="rotate(-180 8 8)"
                stroke="#fff"
                strokeOpacity=".92"
                strokeWidth="1.6"
            />
            <path
                d="M9.075 10.61c.04.508-.453 1.073-1.075 1.073-.62 0-1.113-.562-1.075-1.068l.272-3.251c.025-.343.372-.709.792-.709.418 0 .764.365.791.706l.295 3.25Z"
                fill="#fff"
                fillOpacity=".92"
            />
            <circle
                cx="7.999"
                cy="5.176"
                r=".859"
                transform="rotate(-180 8 5.176)"
                fill="#fff"
                fillOpacity=".92"
            />
        </svg>
    );
};

export default React.memo(ErrorIcon);
